function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F03800"
    },
    points: "401.488,276.142 357.347,324.606 336.966,346.98 298.847,388.832 393.344,512    414.97,439.593 389.799,393.388 440.092,422.848 512,420.927  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CD0000"
    },
    points: "440.092,422.848 357.347,324.606 336.966,346.98 414.97,439.593 419.799,423.388  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF641A"
    },
    points: "175.111,347.613 154.836,325.318 112.606,278.881 0,412.328 69.361,418.821    118.729,390.546 92.71,437.752 109.604,512 214.208,390.604  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F03800"
    },
    points: "69.361,418.821 88.729,420.546 92.71,437.752 175.111,347.613 154.836,325.318  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECECF1"
    },
    d: "M415.3,56.8C368.2,19.3,312.1,0,256,0S143.8,19.3,96.7,56.8L91,61.3v142.5   c0,92.699,55.499,174.598,141.301,208.799l23.699,9.6l23.699-9.6C365.501,378.399,421,296.499,421,203.8V61.3L415.3,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D8"
    },
    d: "M421,61.3v142.5c0,92.699-55.499,174.598-141.301,208.799l-23.699,9.6V0   c56.1,0,112.2,19.3,159.3,56.8L421,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb5757"
    },
    d: "M243.409,384.731C169.048,355.092,121,284.072,121,203.8V75.935C160.646,46.264,208.311,30,256,30   s95.354,16.264,135,45.935V203.8c0,80.271-48.048,151.291-122.409,180.931l-12.591,5.1L243.409,384.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db5353"
    },
    d: "M268.591,384.731C342.952,355.092,391,284.072,391,203.8V75.935C351.354,46.264,303.689,30,256,30   v359.831L268.591,384.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA2D"
    },
    d: "M287.199,182.8L256,140.799L224.801,182.8L175,199.6l30.3,42.9l0.601,52.5L256,279.099L306.099,295   l0.601-52.5l30.3-42.9L287.199,182.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.002,
    y: 121.002,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 153.5736 -98.7595)",
    style: {
      fill: "#FFDA2D"
    },
    width: 29.997,
    height: 29.997
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.938,
    y: 75.938,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 10.6339 207.6726)",
    style: {
      fill: "#FFDA2D"
    },
    width: 30.124,
    height: 30.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.002,
    y: 121.002,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 188.7208 -183.6123)",
    style: {
      fill: "#FF9100"
    },
    width: 29.997,
    height: 29.997
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9100"
    },
    points: "277.301,91 256,112.301 256,69.699  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9100"
    },
    points: "337,199.6 306.7,242.5 306.099,295 256,279.099 256,140.799 287.199,182.8  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedComplete);
export default __webpack_public_path__ + "static/media/RedComplete.68074412.svg";
export { ForwardRef as ReactComponent };